import React, {Fragment} from "react";
import {useDispatch} from "react-redux";
import {useNavigate, useLocation} from "react-router-dom";
import ListView from "../../../components/ContentDisplay/ListView";
import {saveSelectedControler} from "../../../redux/Actions/controllers.actions";
import {getSiteAndLocationForFavouriteController} from "../../../redux/Actions/sites.actions";
import Card from "./card";
import {LIST_HEADERS} from "./constants";
import {useListControllersWithActiveAlerts} from "./useListControllersWithActiveAlerts";

const ControllersWithActiveAlert = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {items} = useListControllersWithActiveAlerts();

  const handleRowSelection = (selectedRow) => {
    const {inventory = {}} = selectedRow;
    dispatch(
      getSiteAndLocationForFavouriteController(inventory.site_id, inventory.location_id)
    );
    dispatch(saveSelectedControler(inventory));
    navigate(`/app/appliance/${inventory.mac}`, {
      state: {previous: location.pathname},
    });
  };

  return (
    <Fragment>
      {items.length > 0 && (
        <div className="table-container">
          <div
            style={{
              fontSize: "25px",
              color: "#073e57",
              paddingBottom: "8px",
            }}
            className="roboto-bold"
          >
            Appliance(s) With Active Alerts
          </div>
          <ListView
            cardContent={Card}
            listHeaders={LIST_HEADERS}
            listItems={items}
            onSelectRow={handleRowSelection}
            rowClickable
            tableName="controllers-with-active-alert"
            withActions={false}
            withPagination={false}
          />
        </div>
      )}
    </Fragment>
  );
};

export default ControllersWithActiveAlert;
